import type { RootState } from '../index'

export const getPageInfo = (state: RootState) =>
  state.priceHistory?.pageInfo ?? null

const emptyArray = []
export const getItems = (state: RootState) =>
  state.priceHistory?.items ?? emptyArray
export const getChartData = (state: RootState) =>
  state.priceHistory?.chartData ?? emptyArray
export const getProduct = (state: RootState) => state.priceHistory?.product

export const getSorting = (state: RootState) =>
  state.priceHistory?.sorting ?? {}
export const getRangeValue = (state: RootState) =>
  state.priceHistory?.rangeValue ?? null

export const getQueryString = (state: RootState) =>
  state.priceHistory?.query ?? ''

export const getSelectedItems = (state: RootState) =>
  state?.priceHistory?.selectedItems ?? emptyArray

export const getOptions = (state: RootState) => state.priceHistory.options
export const getTableName = (state: RootState) => state.priceHistory.tableName
export const getFilter = (state: RootState) => state.priceHistory.filter
